import type { SVGProps } from 'react';
const DawnFlagKH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-KH_svg__a)">
      <path fill="#0F3EB6" d="M0 4.267h22V0H0zM0 16h22v-4.267H0z" />
      <path fill="#ED1A3C" d="M0 11.733h22V4.267H0z" />
      <path
        fill="#fff"
        d="M9.429 6.982h1.047V6.39a.524.524 0 0 1 1.048 0v.59h1.048V8H9.429zm4.19-.582a.524.524 0 0 0-.524.524V8h1.048V6.924a.524.524 0 0 0-.524-.524m-4.714 4.267V8.533H7.857L6.81 10.667zm.524-2.134v2.134h3.143V8.533zm3.666 2.134V8.533h1.048l1.047 2.134zM8.381 6.4a.524.524 0 0 0-.524.524V8h1.048V6.924A.524.524 0 0 0 8.38 6.4"
      />
    </g>
  </svg>
);
export default DawnFlagKH;
